export const APP_ID = import.meta.env.VITE_SENDBIRD_APP_ID as string;
export const GIPHY_API_KEY = import.meta.env.VITE_GIPHY_API_KEY as string;
export const DEFAULT_TIMEZONE = "America/New_York";

export const INTERNAL_OPS_CUSTOM_TYPES = [
  "INTERNAL_DIRECT",
  "INTERNAL_COHORT",
  "INTERNAL_GROUP",
] as const;
